module.exports = __webpack_public_path__ + "static/media/bg-gold.6eb0dfd4.png";